import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import WidgetHeader from '../Widget/WidgetHeader';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { isLongText } from '../../components/Shared/commonFunctions';
import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import CssTransition from '../../components/Transition/CssTransition';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import ShareDrawer from '../../components/ShareDrawer';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import { ImageBanner } from '../../components/Link/Components';

import { Container } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    PeopleSigned,
    Title
} from '../DefaultStyles/Shared';

import { isPortrait } from '../../utils/size';
import { pictureUrl } from '../../utils/imageLoading';
import { Placeholders } from '../../utils/fillDynamicText';
import { ActionTypes, CardTypes } from '../../utils/enums';
import {
    buildCachedAddress,
    relevantRepresentatives,
    joinEnglish,
    districtInfo
} from '../../utils/localRepresentative/parser';

import {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    goToFindLocalRep,
    selectAction
} from '../LocalRep/actions';

import {
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible,
    onBackWithinCard
} from '../Widget/actions';

import { copyFor, capitalization } from '../../copy/copy';
import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';

export class SingleAction extends React.Component {
    constructor(props) {
        super(props);
        if (!props.localRepFound && props.useLocalRepresentative) {
            props.loadLocalRep(
                props.endUserLocation,
                props.cachedAddress,
                props.representativeSearch
            );
        }
    }

    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.actions.map(a => (
                    <LocalRepAction
                        isLongText={
                            !isPortrait() &&
                            isLongText(this.props.cardTitle, 40) &&
                            isLongText(this.props.cardDescription, 90)
                        }
                        action={a}
                        text={a.label}
                        key={a.identifier}
                        onClick={() => {
                            if (
                                (this.props.localRepFound &&
                                    this.props.representatives.length) ||
                                !a.useLocalRepresentative
                            ) {
                                this.props.selectAction(a.identifier);
                                return this.props.onGoToNextActionInsideCard(
                                    a.identifier,
                                    a.type,
                                    true,
                                    false
                                );
                            } else {
                                this.props.selectAction(a.identifier);
                                this.props.goToFindLocalRep(a.identifier, a.type);
                            }
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }
    overlayComponents() {}

    render = () => (
        <Container
            desktopLinkImage={
                this.props.actionTypeSupportsVisualLink &&
                !!this.props.desktopImageId &&
                this.props.isVisualLink &&
                !isPortrait()
            }
        >
            <Overlay />
            <OverlayPublisher />
            <OverlayPartner transitionType="right-to-left" />
            <TransitionGroup>
                {this.props.addressValidationError && (
                    <CssTransition key="alert" in={this.props.addressValidationError}>
                        <ToasterAlert content={this.props.addressValidationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
            <Body className="body-msn-override" isBlured={this.props.showFindYouRepPopup}>
                <WidgetHeader />
                <Content
                    isContactAction={this.props.isContactAction}
                    useLocalRepresentative={this.props.useLocalRepresentative}
                    isSingleAction={this.props.actions.length === 1}
                >
                    <Title
                        isShortText={!isLongText(this.props.cardTitle, 28)}
                        isLongText={isLongText(this.props.cardTitle, 60)}
                        isExtraLongText={isLongText(this.props.cardTitle, 95)}
                        isLocalRepLoading={this.props.isLocalRepLoading}
                        onClick={e => this.props.setOverlayPartnerVisible(true, e, false)}
                        dangerouslySetInnerHTML={{
                            __html: this.props.cardTitle
                        }}
                    />
                    <DetailsContainer>
                        <MultiImageBlock
                            isLongTitle={isLongText(this.props.cardTitle, 40)}
                            isLocalRepLoading={this.props.isLocalRepLoading}
                            imgSources={
                                this.props.useLocalRepresentative
                                    ? this.props.localRepImages.length > 0
                                        ? this.props.localRepImages
                                        : [DefaultRepImageURL]
                                    : this.props.pictureUrl
                                        ? [this.props.pictureUrl]   //eslint-disable-line
                                        : []                        //eslint-disable-line
                            }
                        />
                        <Details
                            hasPhoto={
                                this.props.useLocalRepresentative || this.props.pictureUrl
                            }
                        >
                            {this.props.cardDescription.length > 0 && (
                                <Description
                                    isLocalRepLoading={this.props.isLocalRepLoading}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.cardDescription
                                    }}
                                    isSingleAction={this.props.actions.length === 1}
                                    isLongText={isLongText(
                                        this.props.cardDescription,
                                        90
                                    )}
                                    isExtraLongText={isLongText(
                                        this.props.cardDescription,
                                        160
                                    )}
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(
                                            true,
                                            e,
                                            false
                                        )
                                    }
                                />
                            )}
                            {!!this.props.noOfAnswers && this.props.showNoOfAnswers && (
                                <PeopleSigned>
                                    {this.props.noOfAnswers}{' '}
                                    {copyFor(
                                        'miscellaneous',
                                        'numAnswered',
                                        this.props.activeAction.type,
                                        capitalization.all
                                    )}
                                </PeopleSigned>
                            )}
                        </Details>
                    </DetailsContainer>
                </Content>
                {this.buttonComponent()}
                {this.props.actionTypeSupportsVisualLink && this.props.isVisualLink && (
                    <ImageBanner
                        desktopImageId={this.props.desktopImageId}
                        mobileImageId={this.props.mobileImageId}
                    />
                )}
                <Footer>
                    <ShareDrawer
                        newsletterSignUpVisible={
                            this.props.activeAction.type === ActionTypes.Tweet &&
                            this.props.useLocalRepresentative
                                ? false
                                : true
                        }
                        goBack={() =>
                            this.props.card.type === CardTypes.actionChoice
                                ? this.props.onBackWithinCard(
                                      this.props.actionIdentifier,
                                      this.props.card,
                                      true
                                  )
                                : null
                        }
                        fullwidth={
                            this.props.card.type === CardTypes.actionChoice ||
                            this.props.activeAction.type === ActionTypes.Call ||
                            this.props.activeAction.type === ActionTypes.Email ||
                            this.props.activeAction.type === ActionTypes.Petition
                        }
                        hasBackButton={this.props.card.type === CardTypes.actionChoice}
                        backgroundColor={'#fff'}
                    />
                </Footer>
            </Body>
            <TransitionGroup>
                {this.props.showFindYouRepPopup && (
                    <CssTransition key="alert" in={this.props.showFindYouRepPopup}>
                        <FindLocalRepPopup
                            address={this.props.address}
                            submitting={this.props.isLocalRepPopupLoading}
                            hideFindRepPopup={this.props.hideFindRepPopup}
                            onSubmit={() =>
                                this.props.loadLocalRep(
                                    this.props.endUserLocation,
                                    encodeURI(this.props.address),
                                    this.props.representativeSearch,
                                    true
                                )
                            }
                        />
                    </CssTransition>
                )}
            </TransitionGroup>
            {this.overlayComponents()}
        </Container>
    );
}

SingleAction.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    actions: PropTypes.array.isRequired,
    actionTypeSupportsVisualLink: PropTypes.bool.isRequired,
    activeAction: PropTypes.object.isRequired,
    address: PropTypes.string.isRequired,
    addressValidationError: PropTypes.any,
    card: PropTypes.object.isRequired,
    cardDescription: PropTypes.string.isRequired,
    cachedAddress: PropTypes.string,
    cardTitle: PropTypes.string.isRequired,
    desktopImageId: PropTypes.string,
    endUserLocation: PropTypes.object,
    goToFindLocalRep: PropTypes.func.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    isContactAction: PropTypes.bool,
    isLocalRepLoading: PropTypes.bool,
    isLocalRepPopupLoading: PropTypes.bool.isRequired,
    isVisualLink: PropTypes.bool,
    loadLocalRep: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepImages: PropTypes.array.isRequired,
    mobileImageId: PropTypes.string,
    noOfAnswers: PropTypes.string.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    pictureUrl: PropTypes.string,
    representatives: PropTypes.array,
    representativeSearch: PropTypes.object,
    selectAction: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    showNoOfAnswers: PropTypes.bool,
    useLocalRepresentative: PropTypes.bool
};

export const parseSingleActionProps = state => {
    let reps = state.localRep.localRepData
        ? relevantRepresentatives(
              state.widget.activeAction.representativeSearch,
              state.localRep.localRepData.representative
          )
        : [];
    const contactKey =
        state.widget.activeAction.type === 'email'
            ? 'canBeEmailed'
            : state.widget.activeAction.type === 'call'
            ? 'phone'
            : 'fullName';
    const contactableReps = reps.filter(rep => !!rep[contactKey]);
    if (contactableReps.length) reps = contactableReps;
    reps = reps.slice(0, 3);

    const currActionChoiceIndex = state.actionChoiceCard.activeCarouselActionIndex;
    const currCard = state.widget.cards[state.widget.activeAction.order - 1];
    const currCardTitle =
        currCard.type === CardTypes.actionChoice
            ? state.widget.activeAction.name || currCard.heading || ''
            : currCard.heading || state.widget.activeAction.name || '';
    const currCardDescription =
        currCard.type === CardTypes.actionChoice
            ? state.widget.activeAction.description || currCard.subHeading || ''
            : currCard.subHeading || state.widget.activeAction.description || '';

    return {
        address: state.form.google_autocomplete
            ? state.form.google_autocomplete.values.address
            : '',
        addressValidationError: state.widget.addressValidationError,
        actionIdentifier: state.widget.activeAction.identifier,
        activeAction: state.widget.activeAction,
        card: state.widget.cards[state.widget.activeAction.order - 1],
        desktopImageId: state.widget.activeAction.desktopImageId,
        mobileImageId: state.widget.activeAction.mobileImageId,
        isLocalRepLoading: state.localRep.isLocalRepLoading,
        localRepFound: state.localRep.localRepData.representative !== undefined,
        localRepImages: reps.map(rep => rep.photoUrl || DefaultRepImageURL),
        isLocalRepPopupLoading: state.localRep.isLocalRepPopupLoading,
        isVisualLink: state.widget.activeAction.isVisual,
        actionTypeSupportsVisualLink:
            state.widget.activeAction.type === ActionTypes.Poll ||
            state.widget.activeAction.type === ActionTypes.Quiz,
        pictureUrl: pictureUrl(state),
        representatives: reps,
        representativeSearch: state.widget.maximumRepresentativeSearch,
        showFindYouRepPopup: state.localRep.showFindYouRepPopup,
        cardTitle: currCardTitle
            .replace(/@articleUrl/g, state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.postalCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                reps.length > 0
                    ? joinEnglish(reps.map(rep => `${rep.shortName}${districtInfo(rep)}`))
                    : `Speakable`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            ),
        useLocalRepresentative: !!state.widget.activeAction.representativeSearch,
        isContactAction:
            state.widget.activeAction.type === ActionTypes.Email ||
            state.widget.activeAction.type === ActionTypes.Tweet ||
            state.widget.activeAction.type === ActionTypes.Call ||
            state.widget.activeAction.type === ActionTypes.Petition,
        regularRowSize: state.widget.regularRowSize,
        noOfAnswers: !!state.widget.activeAction.noOfAnswers
            ? state.widget.activeAction.noOfAnswers.toLocaleString()
            : null,
        actions: state.widget.actions
            .filter(a => {
                return currCard.type === CardTypes.actionChoice
                    ? a.id === currCard.actions[currActionChoiceIndex].id
                    : a.id === state.widget.activeAction.id;
            })
            .map(a => ({
                label:
                    a.customButtonText !== undefined
                        ? a.customButtonText
                        : copyFor('buttons', 'start', a.type),
                identifier: a.identifier,
                type: a.type,
                name: a.name,
                useLocalRepresentative: !!a.representativeSearch,
                position: state.widget.cards[
                    state.widget.activeAction.order - 1
                ].actions.indexOf(a)
            }))
            .slice(0, 1),
        cardDescription: currCardDescription
            .replace(new RegExp(Placeholders.ArticleUrl, 'g'), state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.postalCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                reps.length > 0
                    ? joinEnglish(reps.map(rep => `${rep.shortName}${districtInfo(rep)}`))
                    : `Congress`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            )
            .replace(
                new RegExp(Placeholders.NumberOfAnswers, 'g'),
                state.widget.activeAction.noOfAnswers || '121'
            ),
        showNoOfAnswers:
            state.widget.activeAction.type === ActionTypes.Petition ||
            state.widget.activeAction.type === ActionTypes.Quiz ||
            state.widget.activeAction.type === ActionTypes.Poll,
        endUserLocation: state.widget.endUserLocation,
        cachedAddress: buildCachedAddress(
            state.form.google_autocomplete
                ? state.form.google_autocomplete
                : state.cachedFormData
        )
    };
};

export const requiredFunctionsForSingleAction = {
    onFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    onGoToNextActionInsideCard,
    goToFindLocalRep,
    setOverlayPartnerVisible,
    selectAction,
    onBackWithinCard
};

export default connect(
    state => parseSingleActionProps(state),
    requiredFunctionsForSingleAction
)(SingleAction);
